import { all } from 'redux-saga/effects';

import assignedSagas from './assigned';
import divisionSagas from './division';
import listSagas from './list';

export default function* rootSaga() {
  yield all([listSagas(), divisionSagas(), assignedSagas()]);
}
